import { Monitor } from "lucide-react";

const Header = () => (
  <header className="bg-surface text-ink border-b border-line sticky top-0 z-50" data-testid="site-header">
    <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
      <a href="#top" className="flex items-center gap-3" data-testid="brand-link">
        <Monitor className="w-6 h-6 text-brand" strokeWidth={2} />
        <span className="font-mono text-sm tracking-wider uppercase font-bold text-brand">
          DSS Tender Hub
        </span>
      </a>
      <nav className="hidden md:flex items-center gap-6 font-mono text-xs uppercase text-mute" data-testid="main-nav">
        <a href="#live-notices" className="hover:text-brand transition-colors" data-testid="nav-tenders-link">Warehouse Notices</a>
        <a href="#process" className="hover:text-brand transition-colors" data-testid="nav-process-link">Procurement Protocol</a>
        <a href="#coverage" className="hover:text-brand transition-colors" data-testid="nav-coverage-link">India Hubs</a>
        <a href="/vendor" className="hover:text-brand transition-colors" data-testid="nav-vendor-link">Vendor Desk</a>
      </nav>
      <a
        href="#bid-enquiry"
        className="bg-brand hover:bg-brandhover text-night font-mono text-xs font-bold uppercase tracking-wider px-4 py-2 transition-colors"
        data-testid="header-submit-bid-btn"
      >
        Submit Bid Enquiry
      </a>
    </div>
  </header>
);

export default Header;
